import { createStructuredSelector } from "reselect";
import { getRegistrationData } from "../../app/appSelectors";
import { connect } from "react-redux";
import { closeModalAction } from "../../app/appActions";
import { useCallback } from "react";
import { registrationAction } from "../Login/loginActions";
import RegisterEmailCheck from "../Login/components/RegisterEmailCheck";
import ModalsCloseButton from "./components/ModalsCloseButton/ModalsCloseButton";

function RegisterEmailCheckModal(props) {
    const {closeModalAction, registerData, registrationAction} = props;

    const submitHandler = useCallback((e) => {
        e.preventDefault();
        registrationAction({
            email: e.target.querySelector('[name=email]').value,
            phone: registerData?.phone,
            country: registerData?.country,
            password: registerData?.password,
        });
    }, [registerData, registrationAction]);

    return <>
        <RegisterEmailCheck onSubmit={submitHandler} onClose={closeModalAction}/>
        <ModalsCloseButton/>
    </>
}

const mapStateToProps = createStructuredSelector({
    registerData: getRegistrationData,
});

const mapDispatchToProps = {
    closeModalAction,
    registrationAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterEmailCheckModal);
